import { getCurrentInstance } from "vue";

export function usePermission() {
    const instance = getCurrentInstance()

    return {
        $hasPerm(p) {
            return instance.proxy.$hasPerm(p)
        }
    }
}
